import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/homepage/chimp.png")